<form
  id="mon-entreprise-signup"
  accept-charset="UTF-8"
  [formGroup]="form"
  class="px-5 mt-3"
>
  <fieldset
    class="w-100 border rounded-3 px-4 pb-4 d-flex flex-column align-items-center gap-3"
  >
    <legend class="float-none w-auto px-3 fw-semibold text-primary">
      {{ label }}
    </legend>

    <p-error-notification
      [visible]="!!siretErrorStatus && siretErrorStatus !== 404 && siretErrorStatus !== 422"
      [message]="siretErrorMessage ?? ''"
      [status]="siretErrorStatus"
      (notificationClick)="onNotificationClick()"
    ></p-error-notification>
    <div class="align-self-end text-danger">
      <sup>*</sup><span class="mandatory-field">Champs obligatoires</span>
    </div>
    <p-select
      class="w-100 mt-3"
      [items]="countries"
      label="Pays"
      [selectedItem]="selectedCountry"
      (selected)="onCountrySelected($event)"
    ></p-select>

    <p-input
      *ngIf="
        selectedCountryCode === countryValue.UE ||
        selectedCountryCode === countryValue.FR
      "
      class="w-100"
      [formControl]="form.controls.vatNumber"
      id="vatNumber"
      name="vatNumber"
      label="TVA Intracommunautaire"
      placeholder="Ex : FR40303265045"
      [errorMessage]="getErrorMessage('vatNumber')"
      [required]="
        selectedCountryCode === countryValue.UE ||
        selectedCountryCode === countryValue.FR
      "
    ></p-input>

    <div
      *ngIf="selectedCountryCode === countryValue.FR"
      class="w-100 d-flex flex-column"
      [class.gap-0]="!!siretErrorMessage"
      [class.gap-3]="!siretErrorMessage"
    >
      <div class="d-flex align-items-center gap-2 w-100">
        <p-input
          (inputBlur)="onVerifySiret()"
          (inputChange)="onSiretInputChange()"
          class="flex-fill"
          [formControl]="form.controls.siret"
          id="siret"
          name="siret"
          label="Numéro de SIRET"
          placeholder="Ex : 12345678912345"
          [errorMessage]="getErrorMessage('siret')"
          [withRightIcon]="isSiretVerified"
          [iconPointer]="false"
          [required]="selectedCountryCode === countryValue.FR"
        >
          <i-feather
            rightIcon
            name="check-circle"
            style="color: var(--primary-1)"
          ></i-feather>
        </p-input>
      </div>

      <small
        id="siretErrorMessage"
        class="text-danger align-self-start m-0 p-0"
        *ngIf="siretErrorStatus === 404 || siretErrorStatus === 422"
      >
        {{ siretErrorMessage }}
      </small>
    </div>

    <div class="w-100 d-flex flex-column gap-1">
      <p-select
        class="w-100"
        id="industryType"
        [items]="industryTypeItems"
        label="Secteur d'activité"
        [required]="true"
        [placeholder]="'Sélectionnez votre secteur d\'activité'"
        [selectedItem]="selectedIndustryType"
        (selected)="onIndustryTypeSelected($event)"
        (blur)="onIndustryTypeBlur()"
      ></p-select>
      <small
        class="text-danger align-self-start m-0 p-0"
        *ngIf="getErrorMessage('industryType')"
      >
        {{ getErrorMessage("industryType") }}
      </small>
      <small
        id="industryTypeNotaireNotice"
        class="text-danger align-self-start m-0 p-0"
        *ngIf="form.controls.industryType.value === industryType.NOTAIRE"
      >
        Si vous êtes notaire, merci de vous connecter à Perval via votre
        compte ID.NOT et procéder à la commande dans MON COMPTE.
      </small>
    </div>

    <div class="w-100 d-flex flex-column gap-1">
      <div class="position-relative w-100">
        <p-input
          class="w-100"
          [formControl]="form.controls.legalStatus"
          id="legalStatus"
          name="legalStatus"
          label="Forme juridique"
          placeholder="Ex : Société à Responsabilité Limitée"
          [required]="true"
          [errorMessage]="getErrorMessage('legalStatus')"
          (inputBlur)="onLegalStatusBlur()"
        ></p-input>
        <div
          class="position-absolute top-100 start-0 bg-white w-100 autocomplete-suggestions"
        >
          <p-autocomplete
            [itemsInputAutoCompletion]="
              formesJuridiques | filterLabels: form.controls.legalStatus.value
            "
            [inputValue]="form.controls.legalStatus.value"
            [minItemsToDisplayAutocompletion]="1"
            (autocompletionSelected)="onLegalStatusSelected($event)"
          ></p-autocomplete>
        </div>
      </div>
    </div>

    <div class="w-100 d-flex flex-column gap-1">
      <p-input
        class="w-100"
        [formControl]="form.controls.name"
        id="name"
        name="name"
        label="Nom de l'organisme"
        placeholder="Entrez le nom de votre organisme"
        [errorMessage]="getErrorMessage('name')"
        [disabled]="selectedCountryCode === countryValue.FR && !isNameEditable"
        [required]="true"
      ></p-input>
      <small *ngIf="isNameEditable" class="siret-text align-self-start">
        Aucune dénomination trouvée pour ce SIRET. Veuillez saisir le nom de
        votre entreprise (ex : nom commercial, nom et prénom pour une entreprise
        individuelle).
      </small>
    </div>

    <p-input
      class="w-100"
      [formControl]="form.controls.address1"
      id="address1"
      name="address1"
      label="Adresse"
      placeholder="Ex : 123 Rue de la République"
      [errorMessage]="getErrorMessage('address1')"
      [disabled]="selectedCountryCode === countryValue.FR"
    ></p-input>

    <p-input
      class="w-100"
      [formControl]="form.controls.address2"
      id="address2"
      name="address2"
      label="Adresse 1"
      placeholder="Ex : Batiment A, Etage 2"
      [errorMessage]="getErrorMessage('address2')"
      [disabled]="selectedCountryCode === countryValue.FR"
    ></p-input>

    <p-input
      class="w-100"
      [formControl]="form.controls.address3"
      id="address3"
      name="address3"
      label="Adresse 2"
      placeholder="Complément d'adresse"
      [errorMessage]="getErrorMessage('address3')"
      [disabled]="selectedCountryCode === countryValue.FR"
    ></p-input>

    <div class="d-flex align-items-center gap-4 w-100">
      <p-input
        class="flex-fill"
        [formControl]="form.controls.city"
        id="city"
        name="city"
        label="Ville"
        placeholder="Ex : Paris"
        [errorMessage]="getErrorMessage('city')"
        [disabled]="selectedCountryCode === countryValue.FR"
      ></p-input>

      <p-input
        class="flex-fill"
        [formControl]="form.controls.postalCode"
        id="postalCode"
        name="postalCode"
        label="Code Postal"
        placeholder="Ex : 75001"
        [errorMessage]="getErrorMessage('postalCode')"
        [disabled]="selectedCountryCode === countryValue.FR"
      ></p-input>
    </div>

    <p-input
      class="w-100"
      [formControl]="form.controls.phoneNumber"
      id="phoneNumber"
      name="phoneNumber"
      label="Numéro de téléphone"
      placeholder="Ex : 01 23 45 67 89"
      type="tel"
      [errorMessage]="getErrorMessage('phoneNumber')"
    ></p-input>
  </fieldset>
</form>
